<template>
  <div class="body">
    <van-nav-bar
      title="质保单详情"
      left-text
      left-arrow
      @click-left="onClickLeft"
      class="topNav userinfo"
    />
    <div class="content"></div>
  </div>
</template>

<script>
import { GetGuaranteeDetail } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  activated() {
    let id = this.$route.query.id || "";
    if (id == "") {
      this.$router.go(-1);
    } else {
      GetGuaranteeDetail(id, getLocalStorage("login_token")).then(res => {
          console.log(res)
      });
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: @background;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    padding: 0px 10px;
  }
}
</style>
